const areas = {
  headerButtons: {
    create: {
      createBtn: 'Create',
    },

    import: 'Import',
  },
  table: {
    headers: {
      name: 'Name',
      type: 'Type',
    },
    actions: {
      delete: 'Delete',
      export: 'Export',
    },
    toolTip: {
      noPermission: 'Action not allowed: Permission required',
    },
  },
  toast: {
    error: {
      badResponse: '[Zone] bad server response',
      create: {},
      edit: {},
      delete: '[Zone] Could not delete',
    },
    success: {
      create: {
        default: 'Zone created successfully',
      },
      edit: {},
      delete: {
        default: 'Zones were deleted successfully',
      },
    },
  },
  create: {
    createBtn: 'New',
    successToast: {
      message: 'Success! Zone Created',
    },
    errorToast: {
      message: 'Error Occurred! Could Not Create Zone',
      duplicateMessage: 'An Zone with the chosen name already exists'
    },
    validations: {
      name: 'Name is required',
      type: 'Type is required',
      siteId: 'Site ID is required',
    },
  },
  delete: {
    deleteBtn: 'Delete',
    deleteModal: {
      header: 'Delete Zones?',
      body: 'You are about to delete {{number}} Zones',
    },
    successToast: {
      message: 'Deleted Successfully!',
    },
    errorToast: {
      message: 'Error Occurred! Could Not Delete Zone',
    },
  },
  update: {
    successToast: {
      message: 'Success! Zone Updates',
    },
    errorToast: {
      message: 'Error Occurred! Could Not Update Zone',
    },
    validations: {
      name: 'Name is required',
      type: 'Type is required',
    },
  },
  forms: {
    tabs: {
      general: 'General',
      advancedSettings: 'Advanced Settings',
    },

    header: {
      createArea: {
        title: 'Create',
      },

      updateArea: {
        title: 'Update',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Submit',
        update: 'Submit',
      },
    },

    information: {
      details: {
        header: 'Details',
        fields: {
          showOtherAreas: 'Show Other Zones',
          name: 'Name',
          type: 'Type',
        },
      },
      map: {
        header: 'Map',
      },
      settings: {
        btnAdd: 'Add',
        header: 'Ratio',
        label: 'Choose Ratio Zones',
        notice: 'Ratios containing \'All\' are associated-with and editable across all zones.',
        headerAreaRestrictions: 'Zone Restrictions',
        titleAreaRestrictions: 'Block Actions',
      },
      advancedSettings: {
        consistentPassengerRouting: {
          title: 'Consistent Passenger Routing',
          toolTipInformation:
            'Ensures that the same group of passengers always follows the same route to and from the zone, optimizing travel efficiency and minimizing confusion.',
        },
        sameDriverForGroup: {
          title: 'Same Driver for Group',
          toolTipInformation:
            'Assigns the same driver to transport the group of passengers for both pick-up and drop-off, providing familiarity and consistency for passengers.',
        },
        overrideOptions: {
          bySystemSettings: 'By System Settings',
          enabled: 'Enabled',
          disabled: 'Disabled',
        },
        tripBoardingTime: {
          title: 'Boarding Time',
          toolTipInformation: 'The time it takes to pick up a passenger on their stop (This parameter will impact overall trip duration)',
        },
        waitForBoardingTime: {
          title: 'Wait For Boarding Time',
          toolTipInformation: 'When reaching a stop, the driver will wait until the exact pick-up time, if needed.',
        },
        tripDropOffTime: {
          title: 'Drop-off Time',
          toolTipInformation: 'The time it takes to drop a passenger on their stop (This parameter will impact overall trip duration)',
        },
        maxDropOffEarly: {
          title: 'Max Drop-off Early',
          toolTipInformation: 'Maximum number of minutes a driver can get early relative to the drop-off time set in the reservation',
        },
        maxDropOffDelay: {
          title: 'Max Drop-off Delay',
          toolTipInformation: 'Maximum number of minutes a driver can be late for the drop off time set in the reservation',
        },
        maxBoardingDelay: {
          title: 'Max Boarding Delay',
          toolTipInformation: 'Maximum number of minutes a driver can be late for the pickup time set in the reservation',
        },
        maxBoardingEarly: {
          title: 'Max Boarding Early',
          toolTipInformation: 'Maximum number of minutes a driver can get early relative to the pickup time set in the reservation',
        },
        maxTripDuration: {
          title: 'Max Trip Duration',
          toolTipInformation: 'Maximum duration of a trip in minutes',
        },
        maxSinglePassengerTime: {
          title: 'Max Single Passenger Trip Time',
          toolTipInformation: 'Maximum duration of a trip in minutes per passenger',
        },
      },
    },
  },

  polygoneTypes: {
    operationalArea: 'Operational Zone',
    fares: 'Fares',
    routes: 'Routes',
    block: 'Block',
    restriction: 'Routing/Assign',
  },

  blockActions: {
    createRideSharing: 'Create Journey',
    assignDrivers: 'Assign Drivers',
    createRideSharingAndAssignDrivers: 'Create Journey & Assign Drivers',
  }
};

export default areas;
